import { Injectable, Optional, OnDestroy } from '@angular/core';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders, HttpEvent, HttpEventType, HttpErrorResponse } from '@angular/common/http';
//import { Http, Response, Headers, RequestOptions, Request, RequestMethod, ResponseContentType } from '@angular/http';

import { of as observableOf, Observable, Subject, throwError, concat } from 'rxjs';
import { map } from 'rxjs/operators';

import { LoginService } from '../../auth/login.service';
import { UtilsObjects } from '@app/core/utils/utils.objects';

var configUrl = 'assets/config.json';

//exports
export { LoginService } from '../../auth/login.service';
@Injectable()
export abstract class DataService implements OnDestroy {

  protected onDestroy$ = new Subject<boolean>();

  constructor(
    protected httpClient: HttpClient,
    private loginService: LoginService
  ) {
  }
  ngOnDestroy() {
    this.onDestroy$.next(true);//not used, but could be
    this.onDestroy$.complete();
  }

  protected getRequestHeaders(): HttpHeaders {
    let headers = new HttpHeaders()
      //.set('Authorization', 'Bearer ' + this.loginService.accessToken())
      .set('Cache-control', 'no-cache, no-store')
      .append('Expires', '0')
      .append('Pragma', 'no-cache');

    if (this.loginService.accessToken())//skip null token
      headers = headers.append('Authorization', 'Bearer ' + this.loginService.accessToken());

    return headers;
  }

  protected getAuthorisationHeader(): HttpHeaders {
    let headers = new HttpHeaders()

    if (this.loginService.accessToken())
      headers = headers.append('Authorization', 'Bearer ' + this.loginService.accessToken());
    else
      return null;

    return headers;
  }

  protected addRefreshHeader(headers: HttpHeaders): HttpHeaders {
    headers = headers.append('x-cache-refresh', 'true');

    return headers;
  }

  protected addPeriodSafe(query: string, dateStart?: Date, dateEnd?: Date): string {
    if (dateStart)
      //query += `&dateStart=${dateStart.toISOString().substring(0, 10)}`;//"yyyy-mm-dd"
      query += `&${this.converToDateSafe('dateStart', dateStart)}`;
    if (dateEnd)
      query += `&${this.converToDateSafe('dateEnd', dateEnd)}`;

    return query;
  }

  protected converToDateSafe(paramName: string, date?: Date): string {
    if (paramName && date)
      return `${paramName}=${this.converToDateString(date)}`;

    return `${paramName}=`;
  }

  protected converToDateString(date?: Date): string {
    return `${date.toISOString().substring(0, 10)}`;//"yyyy-mm-dd"
  }

  protected getRequestOptions(): { headers: HttpHeaders } {
    const headers = this.getRequestHeaders();
    return { headers: headers };
  }

  protected getParamsFromObject(model: any): HttpParams {
    let params = new HttpParams({
      fromObject: model
      //or more models/objects
      //fromObject: {
      //  query: query,
      //  sort: sort,
      //  order: order
      //}
    });
    return params;
  }

  protected handleError(error/*: Response*/): Observable<boolean> {
    //console.log('error = ' + error);//log it somewhere? //we have ApplicationHttpInterceptor

    //return Observable.throwError(error);
    //or
    return observableOf(false);
  }

  protected handleErrorWithModel<T>(serviceName = '', operation = 'operation', result = {} as T) {
    return (error: HttpErrorResponse): Observable<T> => {

      return observableOf(result);
    };
  }

  getConfig() {
    return this.httpClient.get(configUrl);
  }

  deleteNullProps(obj) {
    UtilsObjects.deleteNullProps(obj);
  }
}
